import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import showToast from "../../../services/toast";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import React from "react";
import PagesHeader from "ah_utility/PagesHeader";
export var PaymentConfirmationHeader = function (props) {
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: props.responsePolicyConfirmLoading, seeToast: props.seeToast, showToast: showToast, setSeeToast: props.setSeeToast, titleLoading: "Enviando correo..." }), _jsx(PagesHeader, { titlePage: "Confirmación de pago", hideStep: false, steps: props.steps, completed: true })] }));
};
